<script setup lang="ts">
import { computed } from 'vue';
import RadialProgressBar from '@/_core/shared/ui/RadialProgressBar/RadialProgressBar.vue';
import { TReport } from '../../models/types';

const SEVERITY_CARDS = [
  {
    variant: 'high' as const,
    title: 'High priority',
    description: 'Can result in data leaks and privacy violation',
  },
  {
    variant: 'medium' as const,
    title: 'Recommend to fix',
    description: 'May reduce app security',
  },
  {
    variant: 'low' as const,
    title: 'Nice to have',
    description: 'Violate best practices',
  },
];

const props = defineProps<{ reportData: TReport }>();

const stats = props.reportData.statistics;
const total = stats.percentageBySeverity.commonAmountVulnerabilities;

const severityCounts = computed(() =>
  stats.percentageBySeverity.commonAmountVulnerabilitiesBySeverity.reduce(
    (prev, { severity, count }) => {
      prev[severity] = count;
      return prev;
    },
    { low: 0, medium: 0, high: 0, critical: 0 } as Record<string, number>
  )
);
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-2 tw:lg:flex-row tw:lg:gap-4">
    <div
      v-for="card in SEVERITY_CARDS"
      :key="card.variant"
      class="tw:p-4 tw:xl:p-5 tw:flex tw:flex-1 tw:gap-5 tw:rounded-2xl tw:bg-white"
    >
      <div class="tw:shrink-0 tw:flex tw:items-center">
        <RadialProgressBar
          :count="severityCounts[card.variant]"
          :total="total"
          :size="64"
          :variant="card.variant"
        />
      </div>

      <div class="tw:flex tw:flex-col tw:gap-2 tw:justify-center">
        <div class="tw:typography-h2">{{ card.title }}</div>

        <div class="tw:typography-small tw:text-secondary">{{ card.description }}</div>
      </div>
    </div>
  </div>
</template>
